import { AgentFormData } from '../components/config/ConfigSteps.tsx';

export const transformAgentFormData = (data: AgentFormData) => {
    return {
        name: data.name,
        description: data.description,
        instructions: data.instructions.map(({ label, body }) => ({ label, body })),
        erpToolProvider: data.erpToolProvider
            ? { key: data.erpToolProvider.key, integrationId: data.erpToolProvider.integrationId }
            : null,
        masterDataToolProvider: data.masterDataToolProvider
            ? {
                  channelId: data.masterDataToolProvider.channelId,
                  documentType: data.masterDataToolProvider.documentType,
              }
            : null,
        sharepointToolProvider: data.sharepointToolProvider
            ? {
                  integrationId: data.sharepointToolProvider.integrationId,
                  siteId: data.sharepointToolProvider.siteId,
                  driveId: data.sharepointToolProvider.driveId,
                  selectedItems: data.sharepointToolProvider.selectedItems.map(({ id, path }) => ({ id, path })),
                  integrationName: data.sharepointToolProvider.integrationName || null,
                  siteName: data.sharepointToolProvider.siteName || null,
                  driveName: data.sharepointToolProvider.driveName || null,
              }
            : null,
        sftpKnowledgeSource: data.sftpKnowledgeSource
            ? {
                  sftpConfigId: data.sftpKnowledgeSource.sftpConfigId,
                  path: data.sftpKnowledgeSource.path,
              }
            : null,
        knowledgeUrls: (data.knowledgeUrls || []).map((url) => url.trim()).filter(Boolean),
        orderHistoryToolProvider: data.orderHistoryToolProvider
            ? { enabled: data.orderHistoryToolProvider.enabled }
            : null,
        defaultChannels:
            data.defaultChannels &&
            (data.defaultChannels.orderChannelId ||
                data.defaultChannels.orderConfirmationChannelId ||
                data.defaultChannels.rfqChannelId ||
                data.defaultChannels.invoiceChannelId ||
                data.defaultChannels.deliveryNoteChannelId)
                ? {
                      orderChannelId: data.defaultChannels.orderChannelId || null,
                      orderConfirmationChannelId: data.defaultChannels.orderConfirmationChannelId || null,
                      rfqChannelId: data.defaultChannels.rfqChannelId || null,
                      invoiceChannelId: data.defaultChannels.invoiceChannelId || null,
                      deliveryNoteChannelId: data.defaultChannels.deliveryNoteChannelId || null,
                  }
                : null,
        attachmentsEnabled: data.attachmentsEnabled,
        skillNames: data.skillNames,
        triggerIds: data.triggerIds,
        deliveryMethod: data.deliveryMethod,
        outputInstructions: data.outputInstructions.map(({ label, body }) => ({ label, body })),
        teamId: data.teamId || null,
    };
};
